// extracted by mini-css-extract-plugin
export default {"dropDownAndAudio":"style_dropDownAndAudio__wCk-i","cardParent":"style_cardParent__TbsXh","responsive":"style_responsive__pknhe","inResponsive":"style_inResponsive__2b5u5"};